import { render, staticRenderFns } from "./FreeTextActionModal.vue?vue&type=template&id=5895da8c&scoped=true&"
import script from "./FreeTextActionModal.vue?vue&type=script&lang=js&"
export * from "./FreeTextActionModal.vue?vue&type=script&lang=js&"
import style0 from "./FreeTextActionModal.vue?vue&type=style&index=0&id=5895da8c&prod&scoped=true&lang=css&"
import style1 from "./FreeTextActionModal.vue?vue&type=style&index=1&id=5895da8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895da8c",
  null
  
)

export default component.exports